export default __webpack_public_path__ + "static/media/reward-title-ru.0f782e32.svg";